import request from "@/api";
import requestSH from "@/api/indexSH";

//Banner-GetBannerList
export function GetBannerListApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//GetRuleInfoVJ
export function GetRuleInfoVJApi(data){
    return requestSH({
        url:'/api/GOShop/GetRuleInfoVJ',
        method:'post',
        data:data,
    })
}

//獲取客戶公私鑰信息
export function getPublicKeyApi(data){
    return requestSH({
        url:'/api/GOShop/GetPublicKey',
        method:'post',
        data:data,
    })
}

//根據Guid獲取通告內容（外部使用，用戶未登錄狀態）
export function GetNoticeContentByGuidApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//獲取聯絡我們信息
export function GetContactInfoListApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}



// WEBPACK FOOTER //
// ./src/api/common.js